export const GET_IMAGES= 'GET_IMAGES'
export const GET_IMAGES_SUCCESS= 'GET_IMAGES_SUCCESS'
export const GET_IMAGES_ERROR='GET_IMAGES_ERROR'

export const GetImages= (data) => ({
    type: GET_IMAGES,
    payload: data
});
